import React from 'react'
import { useNode } from 'react-pagebuilder/hooks/useNode'
import { useEditor } from 'react-pagebuilder/hooks/useEditor'
import { DownloadLink as Original } from 'components/atoms'
import { DownloadLinkSettings, DownloadLinkFloatingSettings } from './DownloadLinkSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import { getTextEditor } from '../TextEditor'

export const defaultProps = {
  url: '',
}

export const downloadLinkItemParams = (enabled, id, blockProps, children) => ({
  pk: id,
  name: getTextEditor(children?.[0], enabled),
  url: blockProps.url,
})

export const dynamicProps = []

export const DownloadLink: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }

    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(
      (state) => ({
        selected: state.events.selected,
        dragged: state.events.dragged,
        hovered: state.events.hovered,
        customs: state.data.custom,
      }),
      props
    )

    const { enabled } = useEditor(
      (state) => ({
        enabled: state.options.enabled,
      }),
      props
    )

    return (
      <div ref={(ref) => props.retRef(ref)} className={`block-download-link ${props.className}`}>
        <Original
          item={downloadLinkItemParams(enabled, id, blockProps, children)}
          editMode={enabled}
        />
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

DownloadLink.craft = withCraft({
  name: 'DownloadLink',
  defaultProps: defaultProps,
  settings: DownloadLinkSettings,
  floatingSettings: DownloadLinkFloatingSettings,
})
